/**
 * Redirects users who already have report access away from reactivate/subscribe pages.
 * Inverse of search permission middleware on dashboard search routes.
 */
export default function({ store, redirect, app, route }) {
  const permissions = store.state.auth.currentUser?.permissions;

  const guardsByRoute = {
    'dashboard-reactivate': 'peopleReport'
  };

  const guardsByType = {
    phone: 'phoneReport',
    email: 'emailReport',
    address: 'addressReport',
    people: 'peopleReport'
  };

  const resolveSubscribeRedirectRoute = (type, query) => {
    const searchType = type ?? null;
    const hasSearchQuery =
      (!!query.address && searchType === 'address') ||
      (!!query.email && searchType === 'email') ||
      (!!query.phoneNumber && searchType === 'phone');

    if (hasSearchQuery) {
      return { name: 'dashboard-search', query };
    }
    if (!searchType) {
      return { name: 'dashboard-home' };
    }
    // People has no dedicated search route; its reports live on the list page
    if (searchType === 'people') {
      return { name: 'dashboard-reports' };
    }
    return { name: `dashboard.${searchType}` };
  };

  if (route.name === 'dashboard-reactivate') {
    const permission = guardsByRoute['dashboard-reactivate'];
    if (permissions?.[permission]) {
      return redirect(
        app.router.resolve(
          resolveSubscribeRedirectRoute(undefined, route.query)
        ).href
      );
    }
    return;
  }

  if (route.name === 'dashboard-subscribe') {
    const type = route.params.type?.toLowerCase();
    const permission = guardsByType[type];
    if (permission && permissions?.[permission]) {
      return redirect(
        app.router.resolve(resolveSubscribeRedirectRoute(type, route.query))
          .href
      );
    }
  }
}
